import { useEffect, useRef } from 'react';

import { usePagination } from '@/hooks';

interface UseTrackingIconPaginationProps {
  filterKey?: string;
}

const useTrackingIconPagination = ({
  filterKey,
}: UseTrackingIconPaginationProps = {}) => {
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({ initialPage: 1, initialPageSize: 10 });

  const previousFilterKey = useRef(filterKey);

  useEffect(() => {
    if (previousFilterKey.current === filterKey) return;
    previousFilterKey.current = filterKey;
    if (currentPage !== 1) handlePageChange(1);
  }, [filterKey, currentPage, handlePageChange]);

  return {
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
  };
};

export default useTrackingIconPagination;
